<template>
	<div>
		<h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">数据录入  </h2>
		
		<!-- 根据type判断录入还是修改 -->
		<data-template type="insert" :clearData="clearData" :formData="formData"></data-template>
		
	</div>
</template>

<script>
	import DataTemplate from '@/components/DataTemplate'
	
	export default{
		name: 'dataInsert',
		data() {
			return {
				formData: {
					mobile: '',
					yyuserid: '',
					sex: '',
					birth: '',
					examdate: '',
					examplace: '',
					package: ['base'],
					
					height: '',
					weight: '',
					bust: '',
					waist: '',
					hip: '',
					fat: '',
					
					area: '',
					marry: '',
					childcnt: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					disease: [
						{"KDIS": "K01", "LEVEL": "0"},
						{"KDIS": "K02", "LEVEL": "0"},
						{"KDIS": "K03", "LEVEL": "0"},
						{"KDIS": "K04", "LEVEL": "0"},
						{"KDIS": "K05", "LEVEL": "0"},
						{"KDIS": "K06", "LEVEL": "0"},
						{"KDIS": "K07", "LEVEL": "0"},
						{"KDIS": "K08", "LEVEL": "0"},
						{"KDIS": "K09", "LEVEL": "0"},
						{"KDIS": "K10", "LEVEL": "0"},
						{"KDIS": "K11", "LEVEL": "0"},
						{"KDIS": "K12", "LEVEL": "0"},
						{"KDIS": "K13", "LEVEL": "0"}
					],
					oper:[],
					famdis:[],
					
					examine: [
						{"ne": "WBC", "ve": "", "ut": "A"},
						{"ne": "HGB", "ve": "", "ut": "A"},
						{"ne": "PLT", "ve": "", "ut": "A"},
						{"ne": "FG", "ve": "", "ut": "B"},
						{"ne": "HBA1C", "ve": "", "ut": "A"},
						{"ne": "CHOL", "ve": "", "ut": "B"},
						{"ne": "LDLC", "ve": "", "ut": "B"},
						{"ne": "HDLC", "ve": "", "ut": "B"},
						{"ne": "TG", "ve": "", "ut": "B"},
						{"ne": "GOT", "ve": "", "ut": "A"},
						{"ne": "GPT", "ve": "", "ut": "A"},
						{"ne": "ALP", "ve": "", "ut": "A"},
						{"ne": "ALB", "ve": "", "ut": "B"},
						{"ne": "CRE", "ve": "", "ut": "B"},
						{"ne": "UA", "ve": "", "ut": "B"},
						{"ne": "EGFR", "ve": "", "ut": "A"}
					],
					
					operator: ''// 当前后台操作人手机号
				}// 数据存储
			}
		},
		components: {
			DataTemplate
		},
		methods:{
			clearData() {
				this.formData = {
					mobile: '',
					yyuserid: '',
					sex: '',
					birth: '',
					examdate: '',
					examplace: '',
					package: ['base'],
					
					height: '',
					weight: '',
					bust: '',
					waist: '',
					hip: '',
					fat: '',
					
					area: '',
					marry: '',
					childcnt: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					disease: [
						{"KDIS": "K01", "LEVEL": "0"},
						{"KDIS": "K02", "LEVEL": "0"},
						{"KDIS": "K03", "LEVEL": "0"},
						{"KDIS": "K04", "LEVEL": "0"},
						{"KDIS": "K05", "LEVEL": "0"},
						{"KDIS": "K06", "LEVEL": "0"},
						{"KDIS": "K07", "LEVEL": "0"},
						{"KDIS": "K08", "LEVEL": "0"},
						{"KDIS": "K09", "LEVEL": "0"},
						{"KDIS": "K10", "LEVEL": "0"},
						{"KDIS": "K11", "LEVEL": "0"},
						{"KDIS": "K12", "LEVEL": "0"},
						{"KDIS": "K13", "LEVEL": "0"}
					],
					oper:[],
					famdis:[],
					
					examine: [
						{"ne": "WBC", "ve": "", "ut": "A"},
						{"ne": "HGB", "ve": "", "ut": "A"},
						{"ne": "PLT", "ve": "", "ut": "A"},
						{"ne": "FG", "ve": "", "ut": "B"},
						{"ne": "HBA1C", "ve": "", "ut": "A"},
						{"ne": "CHOL", "ve": "", "ut": "B"},
						{"ne": "LDLC", "ve": "", "ut": "B"},
						{"ne": "HDLC", "ve": "", "ut": "B"},
						{"ne": "TG", "ve": "", "ut": "B"},
						{"ne": "GOT", "ve": "", "ut": "A"},
						{"ne": "GPT", "ve": "", "ut": "A"},
						{"ne": "ALP", "ve": "", "ut": "A"},
						{"ne": "ALB", "ve": "", "ut": "B"},
						{"ne": "CRE", "ve": "", "ut": "B"},
						{"ne": "UA", "ve": "", "ut": "B"},
						{"ne": "EGFR", "ve": "", "ut": "A"}
					],
					
					operator: ''// 当前后台操作人手机号
				}
			},
		}
	}
</script>

<style>
</style>
